import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'cliente/{idCliente}/carteira-cliente');

const carteiraClienteActions = {
  pesquisar: { method: 'GET', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, carteiraClienteActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/carteira-cliente/cliente-carteira-implicita.js